import { AutoAwesomeOutlined } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type EnrichedFieldIndicatorProps = {
  show: boolean
}

const EnrichedFieldIndicator: React.FC<EnrichedFieldIndicatorProps> = ({ show }) => {
  const { formatMessage } = useIntl()

  if (!show) {
    return null
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} mt={0.5}>
      <AutoAwesomeOutlined sx={{ fontSize: 14, color: 'communication.dark' }} />
      <Typography variant="caption" sx={{ color: 'communication.dark' }}>
        {formatMessage({ id: 'general.aiEnriched' })}
      </Typography>
    </Stack>
  )
}

export default EnrichedFieldIndicator
